import { getMaxGuestCount } from 'lib/offer/occupancyUtils'
import { pluralizeToString } from 'lib/string/pluralize'

export function getVillaCapacityText(offer: App.VillaOffer | App.VillaOfferSummary) {
  if (!offer.lowestPricePackage) return ''

  const roomRate = offer.lowestPricePackage.roomRate
  if (!roomRate) {
    return ''
  }

  const roomType = offer.lowestPricePackage.roomType
  if (!roomType) {
    return ''
  }

  const capacity = getMaxGuestCount(roomRate.capacities)
  if (!capacity) return ''

  const numberOfBedrooms = roomType.numberOfBedrooms ? ' · ' + pluralizeToString('bedroom', roomType.numberOfBedrooms) : ''
  const numberOfBathrooms = roomType.numberOfBathrooms ? ' · ' + pluralizeToString('bathroom', roomType.numberOfBathrooms) : ''

  return `Up to ${pluralizeToString('guest', capacity)} ${numberOfBedrooms}${numberOfBathrooms}`
}
